import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent {
  inputValue: any;
  type: string = ""
  check: any;
  @Input('InputValue') set value(v: boolean | number) {
    this.check = false
    this.type = typeof v
    if (this.type == 'number') {
      if (v == 1) {
        this.inputValue = 1
        this.check = true

      }
      else {
        this.inputValue = 0
        this.check = false
      }
    }
    if (this.type == 'boolean') {
      if (v == true) {
        this.inputValue = false
        this.check = false
      }
      else {
        this.inputValue = true
        this.check = true
      }
    }
  }
  @Output('updateValue') updateValue = new EventEmitter()



  checkUpdate() {
    if (this.type == 'number') {
      if (this.inputValue == 0) {
        this.inputValue = 0
        this.updateValue.emit({ value: this.inputValue })
        return
      }
      else {
        this.inputValue = 1
        this.updateValue.emit({ value: this.inputValue })
        return
      }
    }
    if (this.type == 'boolean') {
      if (this.inputValue == true) {
        this.inputValue = true
        this.updateValue.emit({ value: this.inputValue })
        return
      }
      else {
        this.inputValue = false
        this.updateValue.emit({ value: this.inputValue })
        return
      }
    }

    // if (this.inputValue == true || this.inputValue == 1) {
    //   this.inputValue = false
    //   this.updateValue.emit(this.inputValue)
    //   return
    // }
    // else {
    //   this.inputValue = true
    //   this.updateValue.emit(this.inputValue)
    // }



  }
}
